// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DuplicateIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DuplicateIcon" ref={forwardedRef} {...props}>
      <path d="M12 2H4.01A1.004 1.004 0 0 0 3 3v9h1.514V3.499H12z" />
      <path d="M10.75 12.25H9v-1.5h1.75V9h1.5v1.75H14v1.5h-1.75V14h-1.5z" />
      <path d="M6 6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm1.5 10.5h8v-10h-8z" />
    </SvgIcon>
  );
});

/**
 * Creates a copy of an item in the same location as the original
 * @public
 */
export const DuplicateIcon = /* @__PURE__ */ Object.assign(
  DuplicateIconComponent,
  { displayName: 'DuplicateIcon' },
);
